import React from 'react';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className="bcontainer mt-5 text-center">
        <h1 className="text-6xl">{t('Oops!')}</h1>
        <h2 className="text-4xl">{t('404 Not Found')}</h2>
        <p>{t('Sorry, an error has occurred. Requested page not found!')}</p>
      </div>
    </React.Fragment>
  );
};

export default NotFoundPage;
